import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerGray } from '../colors';

type MuiTypography = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiTypography'];
  defaultProps?: ComponentsProps['MuiTypography'];
  variants?: ComponentsVariants['MuiTypography'];
};

export const MuiTypography: MuiTypography = {
  styleOverrides: {
    root: { wordBreak: 'break-word' },
    paragraph: {
      fontSize: 14,
      lineHeight: '150%',
      color: tannerGray['900'],
    },
    body1: { fontSize: 14, lineHeight: '150%', color: tannerGray['900'] },
    body2: { fontSize: 12, lineHeight: '150%', color: tannerGray['900'] },
    h1: { fontSize: 28, fontWeight: 800, lineHeight: '150%' },
    h2: { fontSize: 20, fontWeight: 800, lineHeight: '150%' },
    h3: { fontSize: 16, fontWeight: 800, lineHeight: '150%' },
    h4: {
      fontSize: 14,
      fontWeight: 800,
      lineHeight: '150%',
    },
    h5: { fontSize: 16, fontWeight: 'bold', lineHeight: '150%' },
    h6: { fontSize: 16, fontWeight: 'normal', lineHeight: '150%' },
  },
};
